/** Local playtest controls. Authorization is held on the server connection. */
export enum DevTestCommand {
    Invincible,
    UnlimitedAmmo,
    UnlimitedDash,
    FastExtract,
    Helmet,
    Vest,
    Backpack,
    Scope,
    Weapon,
    Heal,
    Refill,
    ReduceHealth
}

export interface DevTestState {
    invincible: boolean
    unlimitedAmmo: boolean
    unlimitedDash: boolean
    fastExtract: boolean
}

export interface DevTestSnapshot extends DevTestState {
    helmet: number
    vest: number
    backpack: number
    scope: number
    weapon: number
}

export function defaultDevTestState(): DevTestState {
    return { invincible: true, unlimitedAmmo: true, unlimitedDash: true, fastExtract: true };
}
